import { render, staticRenderFns } from "./il-shop-email-field.vue?vue&type=template&id=620b45da"
import script from "./il-shop-email-field.vue?vue&type=script&lang=ts"
export * from "./il-shop-email-field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports